/** Chart palette — colorful accent tokens first, Tappeer pink/black as fallbacks. */
export const CHART_PALETTE = [
  'var(--color-accent-third)',
  'var(--color-accent-second)',
  'var(--color-accent-sixth)',
  'var(--color-accent-fourth)',
  'var(--color-secondary-base)',
  'var(--color-primary-base)'
] as const;

/** Palette color at an index, wrapping around. */
export const accentAt = (index: number): string => CHART_PALETTE[index % CHART_PALETTE.length];
